import React from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught an error:", error, errorInfo);
    this.setState({ errorInfo });
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
    if (this.props.onReset) {
      this.props.onReset();
    } else {
      window.location.reload();
    }
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          padding: "32px 24px",
          margin: "24px auto",
          maxWidth: "600px",
          background: "#fff",
          border: "1px solid #fee2e2",
          borderRadius: "12px",
          boxShadow: "0 10px 25px -5px rgba(239, 68, 68, 0.1)",
          textAlign: "center"
        }}>
          <div style={{
            width: "48px",
            height: "48px",
            margin: "0 auto 16px",
            background: "#fee2e2",
            color: "#dc2626",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}>
            <AlertTriangle size={24} />
          </div>
          <h2 style={{ fontSize: "18px", color: "#0f172a", margin: "0 0 8px", fontWeight: 700 }}>
            Something went wrong in this section
          </h2>
          <p style={{ fontSize: "13px", color: "#64748b", margin: "0 0 20px", lineHeight: 1.5 }}>
            {this.state.error?.message || "An unexpected rendering issue occurred."}
          </p>
          <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
            <button
              onClick={this.handleReset}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "6px",
                background: "#0f172a",
                color: "#fff",
                border: "none",
                borderRadius: "6px",
                padding: "8px 16px",
                fontSize: "13px",
                fontWeight: 600,
                cursor: "pointer"
              }}
            >
              <RefreshCw size={14} /> Reload View
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
